import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createDeathDeclaration } from '../../../actions/backoffice/user';
import * as R from "ramda";
import DatePicker, { registerLocale } from 'react-datepicker';
import fr from "date-fns/locale/fr";
import parse from "date-fns/parse";





export const ProcessDeces = ({ userId, birthDate, address }) => {
	registerLocale("fr", fr);
	const dispatch = useDispatch();

	const calendarRef = useRef(null);
	const [date, setDate] = useState({
		selectedDate: new Date()
	});

	const [personalData, setPersonalData] = useState({});


	const [dateManualEdit, setDateManualEdit] = useState(false);
	const [manualDate, setManualDate] = useState(new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'numeric', year: 'numeric' }));
	const today = new Date();

	// useEffect(() => {
	//     if (!R.isNil(selectedDate)) {
	//         setDate({ selectedDate: selectedDate });
	//     }
	// }, [selectedDate]);

	function capitalize(s) {
		if (typeof s !== 'string') return '';
		return s.charAt(0).toUpperCase() + s.slice(1);
	}

	function convertDateToUtc(date) {
		let month = date.getMonth() + 1;
		let monthString = month < 10 ? '0' + month : '' + month;
		let day = date.getDate();
		let dayString = day < 10 ? '0' + day : '' + day;
		return new Date(date.getFullYear() + "-" + monthString + "-" + dayString + "T00:00:00Z");
	}

	function removeSelectedFromCalendar() {
		setTimeout(() => {
			const nodes = window.document.querySelectorAll('.react-datepicker__day--keyboard-selected');
			if (!R.isNil(nodes) && nodes.length > 0) {
				nodes.forEach(element => {
					element.classList.remove(['react-datepicker__day--keyboard-selected']);
				});
			}
		}, 0);
	}


	function onSubmitDeathDeclaration(e) {
		e.preventDefault();
		const options = {
			deathDate: date.selectedDate,
			address: {
				AddressLine1: address.addressLine1,
				PostalCode: address.postalCode,
				City: address.city,
				Country: address.country
			}
		};

		dispatch(createDeathDeclaration(userId, options));
	}


	return (
		<div className="modal fade px-0" id="processDeces" aria-labelledby="processDecesLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-sm">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">User deceased</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="processDecesLabel">client décÈdé</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body py-0">
						<p className="h5 lh-copy mb-gutter">Avant de commencer le processus, veuillez saisir la date du décès. Un mail et un message sera envoyé au reférent pour le prevenir , afin que celui-ci lance la procédure des démarches  administratives à faire suite au décès</p>
						<form className="block" noValidate id="deathDeath"  >
							<div className="alert bg-dim rounded-bottom-left-sm rounded-top-right-sm mb-sm p-sm">
								<div className="row gx-2 gy-1">
									<div className="col">
										<label className="h6 font-weight-bolder my-auto" htmlFor="naissance">Date de naissance</label>
										<p className="fs-lead mb-auto font-weight-demi pt-1">{new Intl.DateTimeFormat('fr-FR', { day: "numeric", month: "long", year: "numeric" }).format(birthDate)}</p>
									</div>
									<div className="col">
										<label className="h6 font-weight-bolder my-auto" htmlFor="naissance">Date de décès *</label>
										<div className="input-group">
											<input required type="text" className="form-control bg-white border-right-0" id="naissance" placeholder="dd/mm/yyyy" defaultValue={manualDate} readOnly />
											<div className="input-group-prepend">
												<div className={"input-group-text border-left-0 rounded-right dropdown"}>
													<i className="eva eva-calendar o-30" role="button" id="dropdownMenuNaissance" data-toggle="dropdown"></i>

													<div className="dropdown-menu dropdown-row dropdown-menu-right shadow-lg rounded-sm" aria-labelledby="dropdownMenuNaissance">
														<div className="dropdown-header gradient-prime">
															<p className="h6 mb-2 o-50">{date.selectedDate.getFullYear()}</p>
															<h1 className="h2 font-weight-bolder mb-6">{capitalize(date.selectedDate.toLocaleDateString('fr-FR', { weekday: 'long' }))}, <br />{capitalize(date.selectedDate.toLocaleDateString('fr-FR', { month: 'long' })) + date.selectedDate.getDate()}</h1>
														</div>
														<div className="dropdown-body">
															<div className="block" onClick={(e) => {
																e.stopPropagation();
																e.nativeEvent.stopImmediatePropagation();
															}}>
																{
																	dateManualEdit === true ? '' :
																		<DatePicker ref={calendarRef}
																			locale="fr"
																			placeholderText=""
																			showMonthDropdown
																			showYearDropdown
																			shouldCloseOnSelect={false}
																			dateFormat="dd-MM-yyyy"
																			selected={date.selectedDate}
																			onChange={(startDate) => {
																				setDate({ ...date, selectedDate: startDate });
																				setManualDate(startDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'numeric', year: 'numeric' }));
																			}}
																			onMonthChange={() => {
																				removeSelectedFromCalendar();
																			}}
																			onYearChange={() => {
																				removeSelectedFromCalendar();
																			}}
																			maxDate={new Date()}
																			inline
																			scrollableYearDropdown={true}
																			yearDropdownItemNumber={(today.getFullYear() - 1900)}
																		/>
																}
															</div>
															<div className="grid grid-2">
																<button type="button" className="btn btn-light">Cancel</button>
																<button type="button" className="btn btn-info" onClick={() => setPersonalData({ ...personalData, birthDate: date.selectedDate })}>Ajouter</button>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div className="modal-footer pt-0">
						<button type="button" className="btn btn-faded" data-dismiss="modal">Annuler</button>
						<button type="submit" className="btn btn-info" data-dismiss="modal" form="deathDeath" onClick={onSubmitDeathDeclaration}>Confirmation de décès</button>
					</div>
				</div>
			</div>
		</div>
	);

};

